import PrimeVue from 'primevue/config'
import Slider from 'primevue/slider';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(PrimeVue, {});
  nuxtApp.vueApp.component('Slider', Slider)
})